export default {
  header: "Approve With Changes",
  title: "Modifications to client requested order",
  subtitle:
    "We will notify your client about the new prescription. The original product ordered by this client will be declined.",
  clientNoteFooter: "Quickly add common client notes",
};
